import axiosInstance from "./axiosInstance";

export const getOrders = (orderStatus, userCommitted, userCommitmentFulfilled) => {
    return axiosInstance.get("/orders", {
        params: {
            orderStatus, userCommitted, userCommitmentFulfilled
        }
    });
};

export const getOrder = (id) => {
    return axiosInstance.get(`/orders/${id}`);
}

export const getPending = async () => {
    const res = await axiosInstance.get(`/orders/pendinglogs`);
    return res;
}

export const finalise = async (id, status, reason = "") => {
    await axiosInstance.post('/orders/finalise', {
        CollectionLogId: id,
        Accepted: status,
        RejectReason: reason
    });
}

export const deleteCommitment = id => {
    return axiosInstance.delete(`/commitments/${id}`);
};

export const getCommitmentByOrder = id => {
    return axiosInstance.get("/commitments", {
        params: {
            orderId: id
        }
    });
}

export const getCommitments = id => {
    return axiosInstance.get("/commitments");
}

export const commitOrder = (id, amount, lat, long) => {
    return axiosInstance.post("/commitments", {
        orderId: id,
        amount,
        latitude: lat,
        longitude: long
    });
}

export const getCommitmentSummary = () => {
    return axiosInstance.get("/commitments/summary");
}

export const updateOrder = (orderId, commitmentId, amount, lat, long) => {
    return axiosInstance.put(`/commitments/${commitmentId}`, {
        orderId: orderId,
        amount,
        latitude: lat,
        longitude: long
    });
}